export const theme = {
  colors: {
    primary: '#eab308',
    primaryHover: '#ca9a06',
    primaryLight: '#fef3c7',
    black: '#0f0f0f',
    darkGray: '#374151',
    gray: '#6b7280',
    lightGray: '#e5e7eb',
    offWhite: '#f9fafb',
    white: '#ffffff',
    bgDark: '#0f0f0f',
    bgLight: '#ffffff',
    bgMuted: '#f9fafb',
  },
  fonts: {
    heading: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    body: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
  },
  fontSizes: {
    xs: '0.75rem', sm: '0.875rem', base: '1rem', lg: '1.125rem',
    xl: '1.25rem', '2xl': '1.5rem', '3xl': '1.875rem', '4xl': '2.25rem',
    '5xl': '3rem', '6xl': '3.75rem',
  },
  fontWeights: { normal: 400, medium: 500, semibold: 600, bold: 700 },
  lineHeights: { tight: 1.1, snug: 1.25, normal: 1.5, relaxed: 1.625 },
  spacing: {
    0: '0', 1: '0.25rem', 2: '0.5rem', 3: '0.75rem', 4: '1rem',
    5: '1.25rem', 6: '1.5rem', 8: '2rem', 10: '2.5rem', 12: '3rem',
    16: '4rem', 20: '5rem', 24: '6rem',
  },
  radii: { none: '0', sm: '0.25rem', md: '0.5rem', lg: '0.75rem', xl: '1rem', full: '9999px' },
  shadows: {
    sm: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
    md: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
    lg: '0 10px 15px -3px rgb(0 0 0 / 0.1)',
    xl: '0 20px 25px -5px rgb(0 0 0 / 0.1)',
  },
  breakpoints: { sm: '640px', md: '768px', lg: '1024px', xl: '1280px' },
  container: { sm: '640px', md: '768px', lg: '1024px', xl: '1200px' },
  transitions: { fast: '150ms ease', normal: '250ms ease', slow: '350ms ease' },
};

export default theme;
